export default __webpack_public_path__ + "static/media/saw-logo-inverse-corrected.61961f50.svg";